import { QRCode } from 'react-qr-code'
import { site } from '@/content/site'
import { cn } from '@/lib/utils'

type MenuQrCodeProps = {
  className?: string
}

export function MenuQrCode({ className }: MenuQrCodeProps) {
  return (
    <div className={cn('menu-qr-code', className)}>
      <QRCode
        value={site.websiteUrl}
        size={512}
        bgColor="transparent"
        fgColor="#1a1a1a"
        level="M"
        aria-hidden
        style={{ height: 'auto', maxWidth: '100%', width: '100%' }}
      />
      <span className="sr-only">Scan to visit {site.websiteDisplay}</span>
    </div>
  )
}
